import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTenant from './tenant.reducer';

export const selectTenantState = createFeatureSelector<fromTenant.State>(
  fromTenant.tenantFeatureKey
);

export const selectTenants = createSelector(
  selectTenantState,
  (state: fromTenant.State) => state.tenants
);

export const selectActiveTenants = createSelector(selectTenantState, (state: fromTenant.State) =>
  state.tenants.filter((t) => t.isActive)
);

export const selectSelectedTenant = createSelector(selectTenantState, (state: fromTenant.State) =>
  state.tenants.find((t) => t.id === state.selectedTenantId)
);

export const selectSelectedTenantId = createSelector(
  selectTenantState,
  (state: fromTenant.State) => state.selectedTenantId
);
